<template>
  <div>
    <!-- A4 SPREADSHEET (LANDSCAPE, PORTRAIT) -->
    <div
      class="responsive-print"
      :id="
        field.temp_prop.paper_size == 0
          ? field.temp_prop.orientation == 0
            ? 'a4-spreadsheet-portrait-page'
            : 'a4-spreadsheet-landscape-page'
          : field.temp_prop.orientation == 0
          ? 'a5-spreadsheet-portrait-page'
          : 'a5-spreadsheet-landscape-page'
      "
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0,0,0,0.13);"
      :style="{
        'font-size': (field.temp_prop.font_size || 8) + 'pt',
        color: field.temp_prop.hasOwnProperty('font_color')
          ? field.temp_prop.font_color.hex
          : '#000',
        background:
          field.temp_prop.hasOwnProperty('bg_color') && field.temp_prop.bg_color.show
            ? field.temp_prop.bg_color.value.hex
            : '#fff',
      }"
    >
      <div class="print-template">
        <!-- Header margin top value as height -->

        <div
          class="invoice-header-block"
          :style="{
            height: field.temp_prop.margin_top + 'in',
            background:
              field.header_prop.is_header_bg_color == 1
                ? field.header_prop.header_bg_color.hex
                : '#fff',
          }"
        ></div>
        <!-- Body -->
        <div
          v-if="field.header_prop.show_doc_title"
          class="invoice-content-layout"
          :style="{
            'padding-right': field.temp_prop.margin_right + 'in',
            'padding-left': field.temp_prop.margin_left + 'in',
          }"
        >
          <div
            class="invoice-layout"
            :style="{
              border:
                field.item_prop.layout.table_border.show +
                'px' +
                ' solid ' +
                field.item_prop.layout.table_border.value.hex,
            }"
          >
            <!-- Page Heading -->
            <div class="invoice-top-heading">
              <h5
                class="text-center"
                :style="{
                  'font-size': field.header_prop.doc_title_size + 'pt',
                  color: field.header_prop.doc_title_color.hex,
                }"
                style="margin-bottom:0 !important;margin-top:0.1in;word-break:break-word"
              >
                {{ field.header_prop.doc_title }}
              </h5>
              <!-- v-if="field.header_prop.show_inv_no" -->
              <div
                :style="{
                  color: field.temp_prop.hasOwnProperty('font_color')
                    ? field.temp_prop.font_color.hex
                    : '#000',
                }"
                class="text-center"
                style="margin-bottom:1px;font-weight:500;word-break:break-word"
              >
                <span
                  v-if="field.header_prop.hasOwnProperty('doc_no') && field.header_prop.doc_no.show"
                  >{{ field.header_prop.doc_no.label }}</span
                >{{
                  field.menu_id == 1
                    ? "Invoice " + $AppDetails.financial_year + "/INV14468"
                    : field.menu_id == 2
                    ? "Quotation " + $AppDetails.financial_year + "/QOT10005"
                    : field.menu_id == 3
                    ? "CreditNote " + $AppDetails.financial_year + "/CN10005"
                    : field.menu_id == 4
                    ? "SalesOrder " + $AppDetails.financial_year + "/ORD10013"
                    : field.menu_id == 5
                    ? "Package " + "PKG10001"
                    : field.menu_id == 7
                    ? "PurchaseOrder " + $AppDetails.financial_year + "/PO10009"
                    : field.menu_id == 8
                    ? "Bill# " + $AppDetails.financial_year + "/BILL5"
                    : field.menu_id == 9
                    ? "VendorCredit " + $AppDetails.financial_year + "/VN10005"
                    : field.menu_id == 10
                    ? "Shipment " + "SHP10001"
                    : ""
                }}
              </div>
            </div>
            <!-- First Block -->
            <div
              class="invoice-first-block spreadsheet-layout-pad"
              style="display:flex;justify-content: space-between;"
            >
              <!-- Organization Details -->
              <div>
                <div
                  v-if="field.header_prop.show_org_name"
                  :style="{
                    color: field.header_prop.org_name_color.hex,
                    'font-size': field.header_prop.org_name_size + 'pt',
                  }"
                  style="margin-bottom:1px;font-weight:500;"
                >
                  Shanki Systems India Pvt Ltd
                </div>

                <div v-if="field.header_prop.show_org_addr" class="custom-invoice-address">
                  <p>JKR Tower</p>
                  <p>5/4 Moonlight Garden</p>
                  <p>Coimbatore Tamil Nadu</p>
                  <p>India 641048</p>
                  <p>Mail: admin@shanki.com</p>
                  <p>{{ field.header_prop.phone }}: 76639488488</p>
                  <p v-if="field.header_prop.hasOwnProperty('fax')">
                    {{ field.header_prop.fax }}: 123122
                  </p>
                  <p style="margin-bottom:0px;">GSTIN: 12ASDF12345A1Z0</p>
                </div>
              </div>
              <div v-if="field.header_prop.show_status_stamp && field.menu_id != 3">
                <span class="stamp is-approved">paid</span>
              </div>
              <!-- Organization Logo -->
              <div>
                <!-- Max width for Logo Block -->

                <!-- Logo Image -->
                <img
                  v-if="field.header_prop.show_logo && imageSrc != ''"
                  :src="imageSrc"
                  :style="{ width: field.header_prop.logo_width + 'px' }"
                  style="max-width:300px;max-height:183.05px;height:auto;"
                />
                <img
                  v-if="field.header_prop.show_logo && imageSrc == ''"
                  src="@/assets/logo/Shanki-logo.png"
                  :style="{ width: field.header_prop.logo_width + 'px' }"
                  style="max-width:300px;max-height:183.05px;height:auto;"
                />
              </div>
            </div>
            <!-- End of First Block -->
            <div
              :style="{
                'border-top':
                  field.item_prop.layout.table_border.show +
                  'px' +
                  ' solid ' +
                  field.item_prop.layout.table_border.value.hex,
              }"
            ></div>

            <!-- Second Block -->
            <div class="invoice-second-block spreadsheet-layout-pad" style="display:flow-root;">
              <div style="display:flex;justify-content: space-between;">
                <!-- Shipping Details -->
                <div
                  class="invoice-details-block-left"
                  style="margin-right:8px"
                  :style="{
                    'border-right':
                      field.item_prop.layout.table_border.show +
                      'px' +
                      ' solid ' +
                      field.item_prop.layout.table_border.value.hex,
                  }"
                >
                  <table class="custom-invoice-details-table">
                    <tbody>
                      <tr v-if="field.menu_id != 3 && field.header_prop.doc_ref_no.show">
                        <td
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold left-label-left"
                          style="word-break:break-word"
                        >
                          {{ field.header_prop.doc_ref_no.label }}
                        </td>
                        <td style="word-break:break-word" class="text-left left-label-right">
                          : TN234556
                        </td>
                      </tr>
                      <tr v-if="field.header_prop.doc_place_supply.show && field.menu_id != 3">
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold left-label-left"
                        >
                          {{ field.header_prop.doc_place_supply.label }}
                        </td>
                        <td style="word-break:break-word" class="text-left left-label-right">
                          : Coimbatore
                        </td>
                      </tr>
                      <tr
                        v-if="
                          field.header_prop.hasOwnProperty('doc_sales_person') &&
                            field.header_prop.doc_sales_person.show &&
                            field.menu_id != 3
                        "
                      >
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold left-label-left"
                        >
                          {{ field.header_prop.doc_sales_person.label }}
                        </td>
                        <td style="word-break:break-word" class="text-left left-label-right">
                          : Elavarasan
                        </td>
                      </tr>
                      <tr
                        v-if="
                          field.header_prop.hasOwnProperty('doc_proj_name') &&
                            field.header_prop.doc_proj_name.show
                        "
                      >
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold left-label-left"
                        >
                          {{ field.header_prop.doc_proj_name.label }}
                        </td>
                        <td style="word-break:break-word" class="text-left left-label-right">
                          : Project Design
                        </td>
                      </tr>
                      <tr v-if="field.menu_id == 1">
                        <td
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold left-label-left"
                          style="padding-right:10px !important;word-break:break-word"
                        >
                          Country of Supply
                        </td>
                        <td style="word-break:break-word" class="text-left left-label-right">
                          : India
                        </td>
                      </tr>
                      <tr v-if="field.menu_id == 1">
                        <td
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold left-label-left"
                          style="padding-right:10px !important;word-break:break-word"
                        >
                          Export Type
                        </td>
                        <td style="word-break:break-word" class="text-left left-label-right">
                          : Shipping
                        </td>
                      </tr>

                      <tr
                        v-if="
                          field.header_prop.hasOwnProperty('payment_terms') &&
                            field.header_prop.payment_terms.show
                        "
                      >
                        <td
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold left-label-left"
                          style="padding-right:10px !important;word-break:break-word"
                        >
                          {{ field.header_prop.payment_terms.label }}
                        </td>
                        <td class="text-left left-label-right" style="word-break:break-word">
                          : Due on Receipt
                        </td>
                      </tr>
                      <tr
                        v-if="
                          field.header_prop.hasOwnProperty('doc_eway_no') &&
                            field.header_prop.doc_eway_no.show
                        "
                      >
                        <td
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold left-label-left"
                          style="padding-right:10px !important;word-break:break-word"
                        >
                          {{ field.header_prop.doc_eway_no.label }}
                        </td>
                        <td class="text-left left-label-right" style="word-break:break-word">
                          : 1233456
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Invoice Details-->
                <div class="invoice-details-block-right" v-if="field.menu_id != 3">
                  <table class="custom-invoice-details-table">
                    <tbody>
                      <tr v-if="field.header_prop.doc_date.show">
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold right-label-left"
                        >
                          {{ field.header_prop.doc_date.label }}
                        </td>
                        <td style="word-break:break-word" class="text-left right-label-right">
                          : {{ getDateFormat(new Date()) }}
                        </td>
                      </tr>
                      <tr v-if="field.header_prop.doc_due_date.show">
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold right-label-left"
                        >
                          {{ field.header_prop.doc_due_date.label }}
                        </td>
                        <td style="word-break:break-word" class="text-left right-label-right">
                          : {{ getDateFormat(new Date()) }}
                        </td>
                      </tr>
                      <tr v-if="field.menu_id == 1">
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold right-label-left"
                        >
                          Shipping Bill No.
                        </td>
                        <td style="word-break:break-word" class="text-left right-label-right">
                          : {{ getDateFormat(new Date()) }}
                        </td>
                      </tr>
                      <tr v-if="field.menu_id == 1">
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold right-label-left"
                        >
                          Shipping Bill Date
                        </td>
                        <td style="word-break:break-word" class="text-left right-label-right">
                          : {{ getDateFormat(new Date()) }}
                        </td>
                      </tr>
                      <tr v-if="field.menu_id == 1">
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold right-label-left"
                        >
                          Shipping Port No.
                        </td>
                        <td style="word-break:break-word" class="text-left right-label-right">
                          : TN234556
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              :style="{
                'border-top':
                  field.item_prop.layout.table_border.show +
                  'px' +
                  ' solid ' +
                  field.item_prop.layout.table_border.value.hex,
              }"
            ></div>
            <!-- End of Second Block -->
            <!-- Third Block-->
            <div
              v-if="field.header_prop.doc_inv_tag.show"
              class="invoice-third-block spreadsheet-layout-pad"
              style="margin:3px 0;"
            >
              <table class="custom-invoice-details-table">
                <tbody>
                  <tr>
                    <td
                      style="word-break:break-word"
                      :style="{
                        color: field.temp_prop.hasOwnProperty('label_color')
                          ? field.temp_prop.label_color.hex
                          : '#000',
                      }"
                      class="text-left semi-bold label-tag-left"
                    >
                      {{ field.header_prop.doc_inv_tag.label }}
                    </td>
                    <td style="word-break:break-word" class="text-left label-tag-right">
                      : Tags1, Tags2, Tags3
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- End of third Block -->
            <!-- <div style=":style="{'border-top':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex}""></div> -->
            <!-- fourth Block -->
            <div class="invoice-fourth-block" style="display:flow-root">
              <div
                class="invoice-address-block"
                style="display:flex;justify-content: space-between;"
              >
                <!-- Bill Address -->
                <div
                  v-if="field.header_prop.doc_bill_to.show"
                  class="bill-address-block"
                  :style="{
                    'border-right':
                      field.item_prop.layout.table_border.show +
                      'px' +
                      ' solid ' +
                      field.item_prop.layout.table_border.value.hex,
                  }"
                >
                  <div
                    :style="{
                      color: field.temp_prop.hasOwnProperty('label_color')
                        ? field.temp_prop.label_color.hex
                        : '#000',
                    }"
                    style="padding:3px 8px;font-weight:500;background:#ebebeb;word-break:break-word"
                  >
                    {{ field.header_prop.doc_bill_to.label }}
                  </div>
                  <div
                    :style="{
                      'border-bottom':
                        field.item_prop.layout.table_border.show +
                        'px' +
                        ' solid ' +
                        field.item_prop.layout.table_border.value.hex,
                    }"
                  ></div>
                  <div
                    class="pl-8x"
                    :style="{
                      'font-size': field.header_prop.cus_name_size + 'pt',
                      color: field.header_prop.cus_name_color.hex,
                    }"
                    style="margin-bottom:1px;font-weight:500;"
                  >
                    Shanki Systems India Pvt Ltd
                  </div>
                  <div class="custom-invoice-address pl-8x">
                    <p>JKR Tower</p>
                    <p>5/4 Moonlight Garden</p>
                    <p>Coimbatore Tamil Nadu</p>
                    <p>India 641048</p>
                    <p>Ph: 76639488488</p>
                    <p>GSTIN: 12ASDF12345A1Z0</p>
                  </div>
                </div>
                <!-- Shipping Address -->
                <div
                  v-if="field.menu_id != 3 && field.header_prop.doc_ship_to.show"
                  class="ship-address-block"
                >
                  <div
                    :style="{
                      color: field.temp_prop.hasOwnProperty('label_color')
                        ? field.temp_prop.label_color.hex
                        : '#000',
                    }"
                    style="padding:3px 8px ;font-weight:500;background:#ebebeb;word-break:break-word"
                  >
                    {{ field.header_prop.doc_ship_to.label }}
                  </div>
                  <div
                    :style="{
                      'border-bottom':
                        field.item_prop.layout.table_border.show +
                        'px' +
                        ' solid ' +
                        field.item_prop.layout.table_border.value.hex,
                    }"
                  ></div>
                  <div
                    class="pl-8x"
                    :style="{
                      'font-size': field.header_prop.cus_name_size + 'pt',
                      color: field.header_prop.cus_name_color.hex,
                    }"
                    style="margin-bottom:1px;font-weight:500;"
                  >
                    Shanki Systems India Pvt Ltd
                  </div>

                  <div class="custom-invoice-address pl-8x">
                    <p>JKR Tower</p>
                    <p>5/4 Moonlight Garden</p>
                    <p>Coimbatore Tamil Nadu</p>
                    <p>India 641048</p>
                    <p>Ph: 76639488488</p>
                    <p>GSTIN: 12ASDF12345A1Z0</p>
                  </div>
                </div>
                <div class="ship-address-block" v-if="field.menu_id == 3">
                  <div
                    :style="{
                      'border-bottom':
                        field.item_prop.layout.table_border.show +
                        'px' +
                        ' solid ' +
                        field.item_prop.layout.table_border.value.hex,
                    }"
                  ></div>
                  <table class="custom-invoice-details-table" style="margin-left: 5px;">
                    <tbody>
                      <tr v-if="field.header_prop.doc_date.show">
                        <td
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold right-label-left"
                          style="word-break:break-word"
                        >
                          {{ field.header_prop.doc_date.label }}
                        </td>
                        <td style="word-break:break-word" class="text-left right-label-right">
                          : {{ getDateFormat(new Date()) }}
                        </td>
                      </tr>
                      <tr v-if="field.header_prop.doc_due_date.show">
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold right-label-left"
                        >
                          {{ field.header_prop.doc_due_date.label }}
                        </td>
                        <td style="word-break:break-word" class="text-left right-label-right">
                          : {{ getDateFormat(new Date()) }}
                        </td>
                      </tr>
                      <tr v-if="field.menu_id == 1">
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold right-label-left"
                        >
                          Shipping Bill No.
                        </td>
                        <td style="word-break:break-word" class="text-left right-label-right">
                          : {{ getDateFormat(new Date()) }}
                        </td>
                      </tr>
                      <tr v-if="field.menu_id == 1">
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold right-label-left"
                        >
                          Shipping Bill Date
                        </td>
                        <td style="word-break:break-word" class="text-left right-label-right">
                          : {{ getDateFormat(new Date()) }}
                        </td>
                      </tr>
                      <tr v-if="field.menu_id == 1">
                        <td
                          style="word-break:break-word"
                          :style="{
                            color: field.temp_prop.hasOwnProperty('label_color')
                              ? field.temp_prop.label_color.hex
                              : '#000',
                          }"
                          class="text-left semi-bold right-label-left"
                        >
                          Shipping Port No.
                        </td>
                        <td style="word-break:break-word" class="text-left right-label-right">
                          : TN234556
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!--End of fourth Block -->
            <!-- Fifth Block -->
            <div class="invoice-fifth-block">
              <table
                class="custom-invoice-line-item-table"
                :style="{
                  'border-top':
                    field.item_prop.layout.table_border.show +
                    'px' +
                    ' solid ' +
                    field.item_prop.layout.table_border.value.hex,
                  'border-bottom':
                    field.item_prop.layout.table_border.show +
                    'px' +
                    ' solid ' +
                    field.item_prop.layout.table_border.value.hex,
                }"
              >
                <thead
                  class="semi-bold"
                  :style="{
                    background: field.item_prop.layout.bg_color.show
                      ? field.item_prop.layout.bg_color.value.hex
                      : '#fff',
                    color: field.item_prop.layout.header_font_color.hex,
                    'font-size': field.item_prop.layout.header_font_size + 'pt',
                  }"
                >
                  <th
                    :style="{ width: field.item_prop.label.item_no.width + '%' }"
                    v-if="field.item_prop.label.item_no.show"
                    class="text-right semi-bold"
                    style="word-break:break-word"
                  >
                    {{ field.item_prop.label.item_no.label }}
                  </th>
                  <th
                    :style="{
                      width:
                        (field.item_prop.label.item.show
                          ? field.item_prop.label.item.width
                          : field.item_prop.label.desc.width) + '%',
                    }"
                    v-if="field.item_prop.label.item.show || field.item_prop.label.desc.show"
                    class="text-left semi-bold"
                    style="word-break:break-word"
                  >
                    <template v-if="field.item_prop.label.item.show">
                      {{
                        field.item_prop.label.item.label +
                          (field.item_prop.label.desc.show
                            ? field.item_prop.label.desc.label
                              ? " & " + field.item_prop.label.desc.label
                              : "& Description"
                            : "")
                      }}
                    </template>
                    <template v-else>
                      {{ field.item_prop.label.desc.label }}
                    </template>
                  </th>
                  <th
                    :style="{ width: field.item_prop.label.hsn.width + '%' }"
                    v-if="
                      field.item_prop.label.hsn.show && field.item_prop.label.hsn.show_in_desc == 0
                    "
                    class="text-right semi-bold"
                    style="word-break:break-word"
                  >
                    {{ field.item_prop.label.hsn.label }}
                  </th>
                  <th
                    :style="{ width: field.item_prop.label.qty.width + '%' }"
                    v-if="field.item_prop.label.qty.show"
                    class="text-right semi-bold"
                    style="word-break:break-word"
                  >
                    {{ field.item_prop.label.qty.label }}
                  </th>
                  <th
                    :style="{ width: field.item_prop.label.rate.width + '%' }"
                    v-if="field.item_prop.label.rate.show"
                    class="text-right semi-bold"
                    style="word-break:break-word"
                  >
                    {{ field.item_prop.label.rate.label }}
                  </th>
                  <th
                    :style="{ width: field.item_prop.label.discount.width + '%' }"
                    v-if="field.item_prop.label.discount.show"
                    class="text-right semi-bold"
                    style="word-break:break-word"
                  >
                    {{ field.item_prop.label.discount.label }}
                  </th>
                  <th
                    :style="{
                      width:
                        (field.item_prop.label.tax.show
                          ? field.item_prop.label.tax.width
                          : field.item_prop.label.tax_amt.width) + '%',
                    }"
                    v-if="field.item_prop.label.tax.show || field.item_prop.label.tax_amt.show"
                    class="text-right semi-bold"
                    style="word-break:break-word"
                  >
                    IGST
                    <!-- {{(field.item_prop.label.tax.show?field.item_prop.label.tax.label:field.item_prop.label.tax_amt.label)}} -->
                  </th>

                  <th
                    :style="{ width: field.item_prop.label.amt.width + '%' }"
                    v-if="field.item_prop.label.amt.show"
                    class="text-right semi-bold"
                    style="word-break:break-word;min-width:80px"
                  >
                    {{ field.item_prop.label.amt.label }}
                  </th>
                </thead>
                <tbody
                  :style="{
                    'font-size': (field.item_prop.layout.item_row_font_size || 8) + 'pt',
                    color: field.item_prop.layout.hasOwnProperty('item_row_font_color')
                      ? field.item_prop.layout.item_row_font_color.hex
                      : '#000',
                    background:
                      field.item_prop.layout.hasOwnProperty('item_row_bg_color') &&
                      field.item_prop.layout.item_row_bg_color.show
                        ? field.item_prop.layout.item_row_bg_color.value.hex
                        : '#fff',
                  }"
                >
                  <tr>
                    <td
                      v-if="field.item_prop.label.item_no.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                      style="vertical-align:top"
                    >
                      1
                    </td>
                    <td
                      v-if="field.item_prop.label.item.show || field.item_prop.label.desc.show"
                      class="text-left"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      <span v-if="field.item_prop.label.item.show">Bournvita</span>
                      <span
                        v-if="field.item_prop.label.desc.show"
                        :style="{
                          'font-size': field.item_prop.layout.item_font_size + 'pt',
                          color: field.item_prop.layout.item_font_color.hex,
                        }"
                        style="display:block"
                        >Bournvita,, is a brand of malted and chocolate malt drink mixes
                        manufactured by Cadburys.</span
                      >
                      <span
                        v-if="
                          field.item_prop.label.hsn.show && field.item_prop.label.hsn.show_in_desc
                        "
                        :style="{
                          'font-size': field.item_prop.layout.item_font_size + 'pt',
                          color: field.item_prop.layout.item_font_color.hex,
                        }"
                        style="display:block"
                        >HSN/SAC Code : 12345</span
                      >
                    </td>
                    <td
                      v-if="
                        field.item_prop.label.hsn.show &&
                          field.item_prop.label.hsn.show_in_desc == 0
                      "
                      style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      12345
                    </td>
                    <td
                      v-if="field.item_prop.label.qty.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      1
                      <span
                        :style="{
                          'font-size': field.item_prop.layout.item_font_size + 'pt',
                          color: field.item_prop.layout.item_font_color.hex,
                        }"
                        style="word-break: break-word"
                        v-if="field.item_prop.label.qty.show_unit"
                        >Bag</span
                      >
                    </td>
                    <td
                      v-if="field.item_prop.label.rate.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      3,000.00
                    </td>
                    <td
                      v-if="field.item_prop.label.discount.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      45.00
                    </td>
                    <td
                      v-if="field.item_prop.label.tax.show || field.item_prop.label.tax_amt.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      <span
                        class="d-block"
                        v-if="
                          field.item_prop.label.hasOwnProperty('tax_amt') &&
                            field.item_prop.label.tax_amt.show
                        "
                        >18.00</span
                      >
                      <span
                        v-if="field.item_prop.label.tax.show"
                        :style="{
                          color: field.item_prop.layout.item_font_color.hex,
                          'font-size':
                            field.item_prop.label.hasOwnProperty('tax_amt') &&
                            field.item_prop.label.tax_amt.show
                              ? '6pt'
                              : '',
                        }"
                        >{{
                          field.menu_id == 5 || field.menu_id == 10 ? "9783161484100" : "12%"
                        }}</span
                      >
                    </td>
                    <td
                      v-if="field.item_prop.label.amt.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      2,955.00
                    </td>
                  </tr>
                  <tr>
                    <td
                      v-if="field.item_prop.label.item_no.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                      style="vertical-align:top"
                    >
                      2
                    </td>
                    <td
                      v-if="field.item_prop.label.item.show || field.item_prop.label.desc.show"
                      class="text-left"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      <span v-if="field.item_prop.label.item.show">Bournvita</span>
                      <span
                        v-if="field.item_prop.label.desc.show"
                        :style="{
                          'font-size': field.item_prop.layout.item_font_size + 'pt',
                          color: field.item_prop.layout.item_font_color.hex,
                        }"
                        style="display:block"
                        >Bournvita,, is a brand of malted and chocolate malt drink mixes
                        manufactured by Cadburys.</span
                      >
                      <span
                        v-if="
                          field.item_prop.label.hsn.show && field.item_prop.label.hsn.show_in_desc
                        "
                        :style="{
                          'font-size': field.item_prop.layout.item_font_size + 'pt',
                          color: field.item_prop.layout.item_font_color.hex,
                        }"
                        style="display:block"
                        >HSN/SAC Code : 12345</span
                      >
                    </td>
                    <td
                      v-if="
                        field.item_prop.label.hsn.show &&
                          field.item_prop.label.hsn.show_in_desc == 0
                      "
                      style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      12345
                    </td>
                    <td
                      v-if="field.item_prop.label.qty.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      2
                      <span
                        :style="{
                          'font-size': field.item_prop.layout.item_font_size + 'pt',
                          color: field.item_prop.layout.item_font_color.hex,
                        }"
                        style="word-break: break-word"
                        v-if="field.item_prop.label.qty.show_unit"
                        >Bag</span
                      >
                    </td>
                    <td
                      v-if="field.item_prop.label.rate.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      900.00
                    </td>
                    <td
                      v-if="field.item_prop.label.discount.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      90.00
                    </td>
                    <td
                      v-if="field.item_prop.label.tax.show || field.item_prop.label.tax_amt.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      <span
                        class="d-block"
                        v-if="
                          field.item_prop.label.hasOwnProperty('tax_amt') &&
                            field.item_prop.label.tax_amt.show
                        "
                        >18.00</span
                      >
                      <span
                        v-if="field.item_prop.label.tax.show"
                        :style="{
                          color: field.item_prop.layout.item_font_color.hex,
                          'font-size':
                            field.item_prop.label.hasOwnProperty('tax_amt') &&
                            field.item_prop.label.tax_amt.show
                              ? '6pt'
                              : '',
                        }"
                        >{{
                          field.menu_id == 5 || field.menu_id == 10 ? "9783161484100" : "12%"
                        }}</span
                      >
                    </td>
                    <td
                      v-if="field.item_prop.label.amt.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      1,710.00
                    </td>
                  </tr>
                  <tr>
                    <td
                      v-if="field.item_prop.label.item_no.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                      style="vertical-align:top"
                    >
                      3
                    </td>
                    <td
                      v-if="field.item_prop.label.item.show || field.item_prop.label.desc.show"
                      class="text-left"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      <span v-if="field.item_prop.label.item.show">Bournvita</span>
                      <span
                        v-if="field.item_prop.label.desc.show"
                        :style="{
                          'font-size': field.item_prop.layout.item_font_size + 'pt',
                          color: field.item_prop.layout.item_font_color.hex,
                        }"
                        style="display:block"
                        >Bournvita,, is a brand of malted and chocolate malt drink mixes
                        manufactured by Cadburys.</span
                      >
                      <span
                        v-if="
                          field.item_prop.label.hsn.show && field.item_prop.label.hsn.show_in_desc
                        "
                        :style="{
                          'font-size': field.item_prop.layout.item_font_size + 'pt',
                          color: field.item_prop.layout.item_font_color.hex,
                        }"
                        style="display:block"
                        >HSN/SAC Code : 12345</span
                      >
                    </td>
                    <td
                      v-if="
                        field.item_prop.label.hsn.show &&
                          field.item_prop.label.hsn.show_in_desc == 0
                      "
                      style="display:table-cell !important;word-break: break-word !important;vertical-align:top !important"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      12345
                    </td>
                    <td
                      v-if="field.item_prop.label.qty.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      3
                      <span
                        :style="{
                          'font-size': field.item_prop.layout.item_font_size + 'pt',
                          color: field.item_prop.layout.item_font_color.hex,
                        }"
                        style="word-break: break-word"
                        v-if="field.item_prop.label.qty.show_unit"
                        >Bag</span
                      >
                    </td>
                    <td
                      v-if="field.item_prop.label.rate.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      800.00
                    </td>
                    <td
                      v-if="field.item_prop.label.discount.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      48.00
                    </td>
                    <td
                      v-if="field.item_prop.label.tax.show || field.item_prop.label.tax_amt.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      <span
                        class="d-block"
                        v-if="
                          field.item_prop.label.hasOwnProperty('tax_amt') &&
                            field.item_prop.label.tax_amt.show
                        "
                        >18.00</span
                      >
                      <span
                        v-if="field.item_prop.label.tax.show"
                        :style="{
                          color: field.item_prop.layout.item_font_color.hex,
                          'font-size':
                            field.item_prop.label.hasOwnProperty('tax_amt') &&
                            field.item_prop.label.tax_amt.show
                              ? '6pt'
                              : '',
                        }"
                        >{{
                          field.menu_id == 5 || field.menu_id == 10 ? "9783161484100" : "12%"
                        }}</span
                      >
                    </td>
                    <td
                      v-if="field.item_prop.label.amt.show"
                      class="text-right"
                      :style="{
                        border:
                          field.item_prop.layout.table_border.show +
                          'px' +
                          ' solid ' +
                          field.item_prop.layout.table_border.value.hex,
                      }"
                    >
                      2,352.00
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- End of Fifth Block -->

            <div
              :style="{
                'border-top':
                  field.item_prop.layout.table_border.show +
                  'px' +
                  ' solid ' +
                  field.item_prop.layout.table_border.value.hex,
              }"
              class="invoice-total-block"
              style="display:flex"
            >
              <!-- Seventh Block -->
              <div
                class="invoice-seventh-block total-words-left float-left"
                :style="{
                  position: field.total_prop.label.show_total_sec == 1 ? 'relative' : 'unset',
                }"
                style="min-height:50px"
              >
                <div
                  class="text-left semi-bold spreadsheet-layout-pad"
                  :style="{
                    'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                    color: field.total_prop.layout.total_font_color || '#000',
                    'background-color': field.total_prop.layout.total_font_color || '#000',
                  }"
                  v-if="field.total_prop.label.show_total_qty"
                >
                  <span :style="{ background: field.total_prop.layout.total_bg_color.value.hex }">{{
                    field.total_prop.label.item_in_total
                  }}</span>
                  : 6.00
                </div>
                <div
                  v-if="field.total_prop.label.show_amt_wrd"
                  class="text-left semi-bold spreadsheet-layout-pad"
                  :style="{
                    position: field.total_prop.label.show_total_sec == 1 ? 'absolute' : 'unset',
                  }"
                  style="bottom:0;left:0;"
                >
                  Total Amount (in words) : Rupees Seven Thousand Eight Hundred And Fifty Nine And
                  Four Paise Only
                </div>
              </div>
              <!-- End of seventh block -->
              <!-- Sixth Block -->
              <!-- Subtotal,total -->
              <!-- Tax,Discount -->
              <!-- Balance Due -->
              <div
                v-if="field.total_prop.label.show_total_sec"
                :style="{
                  'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                  color: field.total_prop.layout.total_font_color || '#000',
                  'border-left':
                    field.item_prop.layout.table_border.show +
                    'px' +
                    ' solid ' +
                    field.item_prop.layout.table_border.value.hex,
                }"
                class="invoice-sixth-block total-right float-right"
                style="margin-left:-1px;position:relative"
              >
                <table
                  class="custom-invoice-total-table"
                  style="width:100%"
                  :style="{ background: field.total_prop.layout.total_bg_color.value.hex }"
                >
                  <tbody>
                    <tr v-if="field.total_prop.label.sub_total.show">
                      <td
                        style="word-break:break-word;"
                        class="text-right semi-bold"
                        :style="{
                          background: field.total_prop.layout.total_bg_color.value.hex,
                          color: field.total_prop.layout.total_font_color.hex,
                          'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                        }"
                      >
                        {{ field.total_prop.label.sub_total.label }}
                      </td>
                      <td
                        :style="{
                          background: field.total_prop.layout.total_bg_color.value.hex,
                          color: field.total_prop.layout.total_font_color.hex,
                          'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                        }"
                        class="text-right semi-bold"
                        style="width:150px;word-break:break-word;"
                      >
                        <span :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }">
                          {{ orgCurrencySymbol }}</span
                        >
                        7,017.00
                      </td>
                    </tr>
                    <tr v-if="field.total_prop.label.show_discount">
                      <td
                        style="word-break:break-word;"
                        :style="{
                          background: field.total_prop.layout.total_bg_color.value.hex,
                          color: field.total_prop.layout.total_font_color.hex,
                          'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                        }"
                        class="text-right"
                      >
                        Discount
                      </td>
                      <td
                        style="width:150px;word-break:break-word;"
                        :style="{
                          background: field.total_prop.layout.total_bg_color.value.hex,
                          color: field.total_prop.layout.total_font_color.hex,
                          'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                        }"
                        class="text-right"
                      >
                        <span :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }">
                          {{ orgCurrencySymbol }}</span
                        >
                        (-)183.00
                      </td>
                    </tr>
                    <tr
                      v-if="
                        field.total_prop.label.hasOwnProperty('total_tax_amt') &&
                          field.total_prop.label.total_tax_amt.show
                      "
                    >
                      <td
                        style="word-break:break-word;"
                        :style="{
                          background: field.total_prop.layout.total_bg_color.value.hex,
                          color: field.total_prop.layout.total_font_color.hex,
                          'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                        }"
                        class="text-right"
                      >
                        {{ field.total_prop.label.total_tax_amt.label }}
                      </td>
                      <td
                        style="width:150px;word-break:break-word;"
                        :style="{
                          background: field.total_prop.layout.total_bg_color.value.hex,
                          color: field.total_prop.layout.total_font_color.hex,
                          'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                        }"
                        class="text-right"
                      >
                        <span :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }">
                          {{ orgCurrencySymbol }}</span
                        >
                        6,834.00
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="word-break:break-word;"
                        :style="{
                          background: field.total_prop.layout.total_bg_color.value.hex,
                          color: field.total_prop.layout.total_font_color.hex,
                          'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                        }"
                        class="text-right"
                      >
                        IGST[12%]
                      </td>
                      <td
                        style="width:150px;word-break:break-word;"
                        :style="{
                          background: field.total_prop.layout.total_bg_color.value.hex,
                          color: field.total_prop.layout.total_font_color.hex,
                          'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                        }"
                        class="text-right"
                      >
                        <span :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }">
                          {{ orgCurrencySymbol }}</span
                        >
                        842.04
                      </td>
                    </tr>
                    <tr
                      v-if="
                        field.total_prop.label.amt_withheld &&
                          field.total_prop.label.show_pay_detail
                      "
                    >
                      <td
                        style="word-break:break-word;"
                        class="text-right semi-bold"
                        :style="{
                          background: field.total_prop.layout.total_bg_color.value.hex,
                          color: field.total_prop.layout.total_font_color.hex,
                          'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                        }"
                      >
                        {{ field.total_prop.label.amt_withheld }}
                        <p v-if="id == 17" class="m-0" style="font-size:6pt;">(Section 194 H)</p>
                      </td>
                      <td
                        style="width:150px;word-break:break-word;"
                        class="text-right semi-bold"
                        :style="{
                          background: field.total_prop.layout.total_bg_color.value.hex,
                          color: field.total_prop.layout.total_font_color.hex,
                          'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                        }"
                      >
                        <span :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }">
                          {{ orgCurrencySymbol }}</span
                        >
                        {{ id == 17 ? "(-)" : "" }}0.00
                      </td>
                    </tr>
                    <tr v-if="field.menu_id == 1 || field.menu_id == 3">
                      <template v-if="field.total_prop.label.show_pay_detail">
                        <td
                          :style="{
                            background: field.total_prop.layout.total_bg_color.value.hex,
                            color: field.total_prop.layout.total_font_color.hex,
                            'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                          }"
                          class="text-right semi-bold"
                          style="word-break:break-word;"
                        >
                          {{ field.total_prop.label.total }}
                        </td>
                        <td
                          style="width:150px;word-break:break-word;"
                          :style="{
                            background: field.total_prop.layout.total_bg_color.value.hex,
                            color: field.total_prop.layout.total_font_color.hex,
                            'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                          }"
                          class="text-right semi-bold"
                        >
                          <span
                            :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }"
                          >
                            {{ orgCurrencySymbol }}</span
                          >
                          7,859.04
                        </td>
                      </template>
                      <template v-else>
                        <td
                          :style="{
                            'font-size': field.total_prop.layout.due_font_size + 'pt',
                            color: field.total_prop.layout.due_font_color.hex,
                            'background-color':
                              field.total_prop.layout.due_bg_color.show == 1
                                ? field.total_prop.layout.due_bg_color.value.hex
                                : '',
                          }"
                          class="text-right semi-bold"
                          style="word-break:break-word;"
                        >
                          {{ field.total_prop.label.total }}
                        </td>
                        <td
                          style="width:150px;word-break:break-word;"
                          :style="{
                            'font-size': field.total_prop.layout.due_font_size + 'pt',
                            color: field.total_prop.layout.due_font_color.hex,
                            'background-color':
                              field.total_prop.layout.due_bg_color.show == 1
                                ? field.total_prop.layout.due_bg_color.value.hex
                                : '',
                          }"
                          class="text-right semi-bold"
                        >
                          <span
                            :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }"
                          >
                            {{ orgCurrencySymbol }}</span
                          >
                          7,859.04
                        </td>
                      </template>
                    </tr>
                    <tr v-else>
                      <td
                        class="text-right"
                        style="word-break:break-word;font-style:italic;"
                        :style="{
                          'font-size': field.total_prop.layout.due_font_size + 'pt',
                          color: field.total_prop.layout.due_font_color.hex,
                          'background-color':
                            field.total_prop.layout.due_bg_color.show == 1
                              ? field.total_prop.layout.due_bg_color.value.hex
                              : '',
                        }"
                      >
                        {{ field.total_prop.label.total }}
                      </td>
                      <td
                        class="text-right"
                        style="width:150px;word-break:break-word;font-style:italic;"
                        :style="{
                          'font-size': field.total_prop.layout.due_font_size + 'pt',
                          color: field.total_prop.layout.due_font_color.hex,
                          'background-color':
                            field.total_prop.layout.due_bg_color.show == 1
                              ? field.total_prop.layout.due_bg_color.value.hex
                              : '',
                        }"
                      >
                        <span :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }">
                          {{ orgCurrencySymbol }}</span
                        >
                        7,859.04
                      </td>
                    </tr>
                    <template
                      v-if="
                        (field.menu_id == 1 || field.menu_id == 3) &&
                          field.total_prop.label.show_pay_detail
                      "
                    >
                      <tr style="background:#fff !important;">
                        <td
                          class="text-right"
                          :style="{
                            background: field.total_prop.layout.total_bg_color.value.hex,
                            color: field.total_prop.layout.total_font_color.hex,
                            'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                          }"
                          style="word-break:break-word;font-style:italic;"
                        >
                          {{ field.total_prop.label.pay_made }}
                        </td>
                        <td
                          class="text-right text-danger"
                          :style="{
                            background: field.total_prop.layout.total_bg_color.value.hex,
                            'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                          }"
                          style="width:150px;word-break:break-word;font-style:italic;"
                        >
                          <span
                            :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }"
                          >
                            {{ orgCurrencySymbol }}</span
                          >
                          (-) 0.00
                        </td>
                      </tr>
                      <tr style="background:#fff !important;">
                        <td
                          class="text-right"
                          :style="{
                            background: field.total_prop.layout.total_bg_color.value.hex,
                            color: field.total_prop.layout.total_font_color.hex,
                            'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                          }"
                          style="word-break:break-word;font-style:italic;"
                        >
                          {{ field.total_prop.label.credits_apply }}
                        </td>
                        <td
                          class="text-right text-danger"
                          :style="{
                            background: field.total_prop.layout.total_bg_color.value.hex,
                            'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                          }"
                          style="width:150px;word-break:break-word;font-style:italic;"
                        >
                          <span
                            :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }"
                          >
                            {{ orgCurrencySymbol }}</span
                          >
                          (-) 0.00
                        </td>
                      </tr>
                      <tr style="background:#fff !important;" v-if="menu_id == 1">
                        <td
                          class="text-right"
                          :style="{
                            background: field.total_prop.layout.total_bg_color.value.hex,
                            color: field.total_prop.layout.total_font_color.hex,
                            'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                          }"
                          style="word-break:break-word;font-style:italic;"
                        >
                          {{ field.total_prop.label.writeoff_amt_label }}
                        </td>
                        <td
                          class="text-right text-danger"
                          :style="{
                            background: field.total_prop.layout.total_bg_color.value.hex,
                            'font-size': (field.total_prop.layout.total_font_size || 7) + 'pt',
                          }"
                          style="width:150px;word-break:break-word;font-style:italic;"
                        >
                          <span
                            :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }"
                          >
                            {{ orgCurrencySymbol }}</span
                          >
                          (-) 0.00
                        </td>
                      </tr>
                      <tr style="background:#fff !important;">
                        <td
                          class="text-right"
                          style="word-break:break-word;font-style:italic;"
                          :style="{
                            'font-size': field.total_prop.layout.due_font_size + 'pt',
                            color: field.total_prop.layout.due_font_color.hex,
                            'background-color':
                              field.total_prop.layout.due_bg_color.show == 1
                                ? field.total_prop.layout.due_bg_color.value.hex
                                : '',
                          }"
                        >
                          {{ field.total_prop.label.bal_due }}
                        </td>
                        <td
                          class="text-right"
                          style="width:150px;word-break:break-word;font-style:italic;"
                          :style="{
                            'font-size': field.total_prop.layout.due_font_size + 'pt',
                            color: field.total_prop.layout.due_font_color.hex,
                            'background-color':
                              field.total_prop.layout.due_bg_color.show == 1
                                ? field.total_prop.layout.due_bg_color.value.hex
                                : '',
                          }"
                        >
                          <span
                            :class="{ 'float-right': field.total_prop.label.currency_syb == 2 }"
                          >
                            {{ orgCurrencySymbol }}</span
                          >
                          7,859.04
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <!-- End of sixth block -->
            </div>

            <div
              :style="{
                'border-top':
                  field.item_prop.layout.table_border.show +
                  'px' +
                  ' solid ' +
                  field.item_prop.layout.table_border.value.hex,
              }"
            ></div>
            <div
              class="text-right spreadsheet-layout-pad"
              style="padding-top: 2px;"
              :style="{ 'font-size': 6 + 'pt' }"
            >
              <i>E. & O.E</i>
            </div>
            <!-- eight Block -->
            <div
              v-if="field.footer_prop.show_term_con"
              class="invoice-eight-block spreadsheet-layout-pad"
            >
              <div
                class="terms-conditions"
                :style="{ 'font-size': field.footer_prop.term_font_size + 'pt' }"
              >
                <div
                  :style="{
                    color: field.temp_prop.hasOwnProperty('label_color')
                      ? field.temp_prop.label_color.hex
                      : '#000',
                  }"
                  class="semi-bold text-left"
                >
                  {{ field.footer_prop.term_label }}
                </div>
                <div style="word-break: break-word;white-space: pre;">
                  Looking forward for your business
                </div>
              </div>
            </div>
            <!--End of eight Block -->
            <div
              :style="{
                'border-top':
                  field.item_prop.layout.table_border.show +
                  'px' +
                  ' solid ' +
                  field.item_prop.layout.table_border.value.hex,
              }"
            ></div>

            <!-- ninth Block  -->
            <div class="invoice-ninth-block spreadsheet-layout-pad" style="display: flow-root;">
              <div class="signature-block">
                <div style="float:right;width:max-content" v-if="field.footer_prop.signature.show">
                  <div
                    class="semi-bold text-right mb-2"
                    :style="{
                      color: field.temp_prop.hasOwnProperty('label_color')
                        ? field.temp_prop.label_color.hex
                        : '#000',
                    }"
                  >
                    {{ field.footer_prop.signature.label }}
                  </div>
                  <hr style="border-color:#000;margin-bottom:5px;margin-top: 1.5rem" />
                  <div class="text-left">{{ field.footer_prop.signature.name }}</div>
                </div>
              </div>
            </div>
            <!--End of  ninth Block  -->

            <!-- Tenth Block -->
            <div class="invoice-tenth-block">
              <div class="invoice-notes" style="margin-bottom:0.1in">
                <div
                  :style="{
                    color: field.temp_prop.hasOwnProperty('label_color')
                      ? field.temp_prop.label_color.hex
                      : '#000',
                  }"
                  class="text-center"
                >
                  {{ field.footer_prop.note_label || "" }}
                </div>
                <div
                  :style="{ 'font-size': field.footer_prop.note_font_size + 'pt' }"
                  class="text-center"
                >
                  Looking forward for your business
                </div>
              </div>
            </div>
            <!-- End of Tenth Block -->
          </div>
        </div>
        <!-- Body End -->
        <div
          class="invoice-footer-block"
          :style="{
            height: field.temp_prop.margin_bottom + 'in',
            background:
              field.footer_prop.bg_color.show == 1 ? field.footer_prop.bg_color.value.hex : '#fff',
            color: field.footer_prop.hasOwnProperty('footer_color')
              ? field.footer_prop.footer_color.hex
              : '#000',
            'font-size': (field.footer_prop.footer_font_size || 7) + 'pt',
          }"
        ></div>
      </div>
    </div>
    <!-- End of A4 SPREADSHEET (LANDSCAPE, PORTRAIT) -->
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import { mapGetters } from "vuex";
export default {
  props: ["list", "id"],
  data() {
    return {
      field: JSON.parse(JSON.stringify(this.list)),
      imageSrc: "",
    };
  },
  methods: {
    preview(eve) {
      this.field = JSON.parse(JSON.stringify(eve));
    },
  },
  created() {
    this.imageSrc =
      this.org_details.org_logo != null && this.org_details.org_logo != ""
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : "";
  },
  mounted() {
    EventBus.$on("preview", this.preview); // to trigger the method from parentcomponent
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapGetters(["org_details", "inv_settings_details", "orgCurrencySymbol"]),
  },
};
</script>
<style lang="scss" scoped>
.clearfix:after,
.clearfix:before {
  content: " ";
  display: table;
}
.ribbon {
  position: absolute !important;
  top: -4px;
  left: -5px;
  overflow: hidden;
  width: 120px;
  height: 120px;
}
td.labels,
td.values {
  padding: 0px !important;
}
.ribbon .ribbon-inner {
  font-size: 13px;
  text-align: center;
  color: #fff;
  top: 34px;
  left: -35px;
  width: 166px;
  padding: 4px;
  position: relative;
  transform: rotate(-45deg);
}
.ribbon .ribbon-inner:before {
  left: 0;
  border-left: 2px solid transparent;
}
.ribbon .ribbon-inner:after {
  right: -2px;
  border-bottom: 3px solid transparent;
}
.ribbon .ribbon-inner:after,
.ribbon .ribbon-inner:before {
  content: "";
  border-top: 5px solid transparent;
  border-left: 5px solid;
  border-left-color: inherit;
  border-right: 5px solid transparent;
  border-bottom: 5px solid;
  border-bottom-color: inherit;
  position: absolute;
  top: 20px;
  transform: rotate(-45deg);
}
@page {
  size: A4;
  margin: 0;
}

div.a4-size {
  margin: 0;
}

div.a4-size .a4-sheet {
  width: 210mm;
  min-height: 100%;
}

div.letter .a4-sheet {
  width: 216mm;
  height: 279mm;
}

/** Padding area **/
.a4-sheet {
  padding: 10mm;
}

/** For screen preview **/
@media screen {
  div.a4-size {
    background: #fff;
  }

  .a4-sheet {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin: 5mm auto;
  }
}
@media screen and (max-width: 1030px) {
  div.a4-size .a4-sheet {
    width: 201mm;
    min-height: 100%;
  }
}
@media screen and (max-width: 1000px) {
  div.a4-size .a4-sheet {
    width: 177mm;
    min-height: 100%;
  }
  .a4-size .title {
    font-size: 20px !important;
  }
}
@media print {
  div.a4-size {
    width: 210mm;
    height: 297mm;
    font-size: 13px;
    page-break-inside: avoid;
  }
}

.a4-size .invoice-details {
  font-size: 14px;
}

.a4-size .table1 table {
  border-collapse: collapse;
  width: 100%;
  padding-top: 15 px;
  padding-top: 3px;
  border-color: #c3c3c3;
}

.a4-size .table1 td,
.a4-size th {
  border: 1px solid #c3c3c3;
  text-align: left;
  padding: 8px;
}

.a4-size .invoice-terms-column {
  height: 90px;
  border: 1px solid #c3c3c3;
  padding: 5px 5px;
}

.a4-size .heading {
  text-align: center;
  font-family: saira-font;
  padding-top: 0px;
  margin-top: 0px;
}

.a4-size .address {
  font-style: initial;
  font-size: 12px;
  line-height: 0.5;
  padding-top: 5px;
}
.a4-size .address p {
  margin-top: 12px;
}

.a4-size .sign {
  float: left;
  padding-left: 5px;
  margin-top: 75px;
}

.a4-size .authored-sign {
  float: right;
  margin-top: 55px;
  padding-right: 5px;
}

.a4-size .header-address {
  margin-left: 8px;
  font-style: initial;
  font-size: 14px;
  line-height: 0.5;
  padding-top: 5px;
}

.a4-size .label {
  width: 45%;
  display: inline-block;
  /* vertical-align: top; */
  font-size: 12px;
}

.a4-size .values {
  padding-top: 4px;
  padding-bottom: 5px;
  font-size: 12px;
  float: right;
  /* text-align: right; */
}
.a4-size .table1 table thead tr {
  border-top: 1px solid #c3c3c3 !important;
}
.a4-size .labels {
  /* width: 45%;
  padding-left: 138px; */
  padding-top: 4px;
  padding-bottom: 5px;
  display: inline-block;
  vertical-align: top;
  font-size: 12px;
}

.a4-size .label1 {
  width: 100%;
  display: inline-block;
  vertical-align: top;
}

.value {
  /* font-weight: 600; */
  font-size: 12px;
}

.a4-size p {
  font-size: 12px;
}

.a4-size .img {
  max-width: 120px;
  max-height: 120px;
  float: left;
  padding-right: 5px;
  padding-bottom: 5px;
  /* margin-top: -150px; */
}

.a4-size .title {
  float: right;
  margin-top: -86px;
  font-size: 25px;
  padding-right: 10px;
}

.inv-no {
  float: right;
  margin-top: -46px;
  font-size: 15px;
  padding-right: 10px;
}

.a4-size table {
  border-spacing: 0;
}

.a4-size .inv-details {
  border-right: 1px solid #c3c3c3;
  border-top: 1px solid #c3c3c3;
  padding: 3px 0px 3px 5px;
  width: 64%;
}

.a4-size .inv-details2 {
  border-top: 1px solid #c3c3c3;
  padding: 3px 0px 3px 5px;
  width: 36%;
}

.a4-size .detail {
  border-collapse: collapse;
  border-spacing: 0;
  border-color: #c3c3c3;
}

.a4-size .detail thead {
  background-color: #efeded;
}

.a4-size .bill {
  width: 50%;
  border-left: none;
  font-size: 12px;
}

.a4-size .ship {
  width: 50%;
  border-right: none;
  font-size: 12px;
}

.a4-size .detail tbody td {
  border-right: 1px solid #c3c3c3;
  padding: 3px 0px 3px 5px;
}

.a4-size .table1 table thead {
  border-left: none;
  border-right: none;
  font-size: 12px;
}

.a4-size .end td {
  /* border-top: 1px solid #c3c3c3; */
  width: 100%;
}

.a4-size .seal td {
  border-top: 1px solid #c3c3c3;
  border-bottom: none;
  width: 1200px;
}

.a4-size .table-details {
  width: 100%;
  margin-top: -1px;
}

.a4-size .table-details table {
  border-spacing: 0;
}

.a4-size .total {
  border-right: 1px solid #c3c3c3;
  border-top: 1px solid #c3c3c3;
  padding: 3px 0px 3px 5px;
  width: 50%;
}

.a4-size .calc {
  border-top: 1px solid #c3c3c3;
  padding: 3px 0;
  width: 50%;
}

.table1.item-line th {
  padding: 5px !important;
}
.text-sm {
  font-size: 12px !important;
}
.table1.item-line td:last-child {
  border-right: 0 !important;
}
.amt_words_block {
  position: relative !important;
}

.amt_words {
  position: absolute !important;
  bottom: 0 !important;
}
.label.label-left {
  width: 24% !important;
}
.invoice_tag_block {
  margin-bottom: 5px !important;
  margin-top: 5px !important;
  margin-left: 8px !important;
}
table.end {
  border-top: 1px solid #c3c3c3 !important;
  width: 100%;
}
.invoice_block {
  outline: 1px solid #c3c3c3;
}
.display-block {
  display: block !important;
}

/* // A4 STANDARD PORTRAIT CSS */
/* // Bootstrap class */
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
/* //Custom css */
/* //A4 spreadsheet portrait */
#a4-spreadsheet-portrait-page {
  width: 21cm;
  min-height: 29.7cm;
}
/* //A4 spreadsheet landscape */
#a4-spreadsheet-landscape-page {
  width: 29.7cm;
  min-height: 21cm;
}
/* //A5 standard landscape */
#a5-spreadsheet-portrait-page {
  width: 14.8cm;
  min-height: 21cm;
}
/* //A5 spreadsheet landscape */
#a5-spreadsheet-landscape-page {
  width: 21cm;
  min-height: 14.8cm;
}
#a4-spreadsheet-portrait-page .print-template {
  zoom: 115%;
}
#a5-spreadsheet-landscape-page .print-template {
  zoom: 78%;
}
#a4-spreadsheet-landscape-page .invoice-content-layout {
  zoom: 110%;
}
.invoice-top-heading {
  margin-bottom: 30px;
}
.custom-invoice-address p {
  margin-bottom: 1px !important;
  font-size: 8pt;
}
.custom-invoice-address {
  margin-bottom: 5px;
}

table.custom-invoice-details-table > tbody > tr > td {
  padding: 1px !important;
}

table.custom-invoice-total-table > tbody > tr > td {
  padding: 2px 8px !important;
}
table.shipping-details-table,
table.custom-invoice-line-item-table tbody > tr > td,
table.custom-invoice-line-item-table {
  border-collapse: collapse;
}

table.shipping-details-table td {
  border: 1px solid #c3c3c3;
  padding: 3px !important;
}
table.custom-invoice-line-item-table thead > th {
  padding: 6px;
}

table.custom-invoice-line-item-table tbody > tr > td {
  padding: 8px !important;
}
.signature-block {
  margin-top: 60px;
}
.terms-conditions {
  width: 100%;

  padding-bottom: 10px;
}
.invoice-details-block-right {
  width: 50%;
}
.invoice-details-block-left {
  width: 50%;
}
.left-label-left {
  width: 50%;
}
.left-label-right {
  width: 50%;
}
.right-label-left {
  width: 50%;
}
.right-label-right {
  width: 50%;
}
table.custom-invoice-details-table,
.invoice-address-block,
.invoice-total-block {
  width: 100%;
}
.label-tag-left {
  width: 15%;
}
.label-tag-right {
  width: 85%;
}

.bill-address-block,
.ship-address-block,
.total-right,
.total-words-left {
  width: 50%;
}
.pl-8x {
  padding-left: 8px;
}
.invoice-notes {
  margin-top: 15px;
}
.spreadsheet-layout-pad {
  padding: 0 0.1in;
}

table.custom-invoice-line-item-table > tbody > tr > td:first-child {
  border-left: 0 !important;
}

table.custom-invoice-line-item-table > tbody > tr > td:last-child {
  border-right: 0 !important;
}

#a5-spreadsheet-portrait-page .left-label-left {
  width: 50%;
}
#a4-spreadsheet-portrait-page .left-label-left {
  width: 50%;
}
#a4-spreadsheet-landscape-page .invoice-details-block-left {
  width: 50%;
}
#a4-spreadsheet-landscape-page .invoice-details-block-right {
  width: 50%;
}
#a4-spreadsheet-landscape-page .left-label-left {
  width: 50%;
}
#a4-spreadsheet-landscape-page .label-tag-left {
  width: 50%;
}
@media (min-width: 10px) and (max-width: 768px) {
  #a4-spreadsheet-portrait-page.responsive-print {
    zoom: 36%;
  }
  #a4-spreadsheet-landscape-page.responsive-print {
    zoom: 26%;
  }
  #a5-spreadsheet-portrait-page.responsive-print {
    zoom: 52%;
  }
  #a5-spreadsheet-landscape-page.responsive-print {
    zoom: 36%;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  #a4-spreadsheet-portrait-page.responsive-print {
    zoom: 50%;
  }

  #a4-spreadsheet-landscape-page.responsive-print {
    zoom: 35%;
  }
  #a5-spreadsheet-portrait-page.responsive-print {
    zoom: 70%;
  }
  #a5-spreadsheet-landscape-page.responsive-print {
    zoom: 50%;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  #a4-spreadsheet-portrait-page.responsive-print {
    zoom: 73%;
  }
  #a4-spreadsheet-landscape-page.responsive-print {
    zoom: 55%;
  }
  #a5-spreadsheet-portrait-page.responsive-print {
    zoom: 100%;
  }
  #a5-spreadsheet-landscape-page.responsive-print {
    zoom: 80%;
  }
}
@media (min-width: 1281px) and (max-width: 1366px) {
  #a4-spreadsheet-portrait-page.responsive-print {
    zoom: 92%;
  }
  #a4-spreadsheet-landscape-page.responsive-print {
    zoom: 64%;
  }
  #a5-spreadsheet-portrait-page.responsive-print {
    zoom: 80%;
  }
  #a5-spreadsheet-landscape-page.responsive-print {
    zoom: 86%;
  }
}
@media (min-width: 1367px) and (max-width: 1440px) {
  #a4-spreadsheet-portrait-page.responsive-print {
    zoom: 75%;
  }
  #a4-spreadsheet-landscape-page.responsive-print {
    zoom: 70%;
  }

  #a5-spreadsheet-landscape-page.responsive-print {
    zoom: 97%;
  }
}
@media (min-width: 1605px) {
  #a5-spreadsheet-landscape-page.responsive-print {
    zoom: 122%;
  }
}
</style>
